import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price);
        total += price * item.quantity;
      }
    });
    return total.toFixed(2);
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
    } else {
      alert("Your cart is empty.");
    }
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="cart-page">
        <div className="cart-container">
          <h1 className="cart-title">YOUR BAG</h1>

          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <p>Your bag is empty</p>
              <Link
                onClick={toTop}
                to="/shop"
                className="continue-shopping-btn"
              >
                CONTINUE SHOPPING
              </Link>
            </div>
          ) : (
            <>
              {/* Cart Items Table */}
              <div className="cart-table">
                <div className="cart-table-header">
                  <div className="header-item">ITEM</div>
                  <div className="header-price">PRICE</div>
                  <div className="header-qty">QTY</div>
                  <div className="header-total">TOTAL</div>
                </div>

                {cartItems.map((item) => {
                  const product = getProductById(item.id);
                  if (!product) return null;

                  const itemTotal = (
                    parseFloat(product.price) * item.quantity
                  ).toFixed(2);

                  return (
                    <div key={`${item.id}-${item.size}`} className="cart-item">
                      <div className="item-info">
                        <div className="item-image">
                          <img
                            src={product.images[0]}
                            alt={product.name}
                            onClick={() => {
                              navigate(`/product/${product.id}`);
                              toTop();
                            }}
                          />
                        </div>
                        <div className="item-details">
                          <h3
                            className="item-name"
                            onClick={() => {
                              navigate(`/product/${product.id}`);
                              toTop();
                            }}
                          >
                            {product.name}
                          </h3>
                          {item.size && (
                            <p className="item-size">SIZE: {item.size}</p>
                          )}
                        </div>
                      </div>

                      <div className="item-price">
                        ${parseFloat(product.price).toFixed(2)}
                      </div>

                      <div className="item-quantity">
                        <div className="quantity-control">
                          <button
                            className="qty-btn"
                            onClick={() =>
                              handleUpdateQuantity(
                                item.id,
                                item.size,
                                item.quantity - 1
                              )
                            }
                          >
                            −
                          </button>
                          <span className="qty-display">{item.quantity}</span>
                          <button
                            className="qty-btn"
                            onClick={() =>
                              handleUpdateQuantity(
                                item.id,
                                item.size,
                                item.quantity + 1
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div className="item-total">${itemTotal}</div>

                      <button
                        className="remove-item"
                        onClick={() => removeFromCart(item.id, item.size)}
                      >
                        REMOVE ITEM
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Continue Shopping Button */}
              <Link
                to="/shop"
                className="continue-shopping-link"
                onClick={toTop}
              >
                <button className="continue-shopping-btn">
                  CONTINUE SHOPPING
                </button>
              </Link>

              {/* Cart Summary */}
              <div className="cart-summary">
                <div className="summary-row">
                  <span className="summary-label">SUBTOTAL</span>
                  <span className="summary-value">${subtotal}</span>
                </div>

                <button className="checkout-btn" onClick={handleCheckout}>
                  CHECKOUT
                </button>
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </body>
  );
};

export default CartPage;
